/**
 * Русское склонение по числу: pluralize(5, ['клиент', 'клиента', 'клиентов']) → 'клиентов'.
 */
export const pluralize = (count, [one, few, many]) => {
    const mod10 = Math.abs(count) % 10;
    const mod100 = Math.abs(count) % 100;
    if (mod10 === 1 && mod100 !== 11) return one;
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
    return many;
};

export const PLURAL = Object.freeze({
    USER: ['пользователь', 'пользователя', 'пользователей'],
    CLIENT: ['клиент', 'клиента', 'клиентов'],
    ADMIN: ['администратор', 'администратора', 'администраторов'],
    PARTNER: ['партнёр', 'партнёра', 'партнёров'],
    ADVERTISER: ['рекламодатель', 'рекламодателя', 'рекламодателей'],
    BRAND: ['бренд', 'бренда', 'брендов'],
    CAMPAIGN: ['кампания', 'кампании', 'кампаний'],
    AGENCY: ['агентство', 'агентства', 'агентств'],
    SCREEN: ['экран', 'экрана', 'экранов'],
    DAY: ['день', 'дня', 'дней'],
});

export const countLabel = (count, forms) => `${count} ${pluralize(count, forms)}`;
